import React, { useEffect, useRef, useState } from "react";
import { Spin, Switch } from "antd";
import { ErrorMessage, Field, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";

import { Constants } from "../../Constants";
import { types } from "../../store/action_types";
import CustomTextInput from "../CustomTextInput";
import { UploadImage } from "../UploadImage";

const AddOrEditTokens = ({
  handleCloseModal,
  isFirstTime,
  setIsFirstTime,
  currentPT,
  isEdit,
  page,
}) => {
  const { createLoading, editLoading } = useSelector(
    (state) => state.TokensReducer
  );
  const BoastImageLink = useSelector(
    (state) => state?.BoostReducer?.uploadBoastimageAllData?.result?.imgLink
  );
  const loading = createLoading || editLoading;
  const [imageFile, setImageFile] = useState(null);
  const formikRef = useRef();
  const dispatch = useDispatch();

  const handleResetForm = () => {
    setImageFile(null);
    formikRef.current.resetForm({
      values: {
        name: "",
        symbol: "",
        iconImgUrl: "",
        contractAddress: "",
        decimals: "",
        totalTokens: "",
        radius: "",
        blockchain: "",
        status: "",
        worldwide: "",
        socialHub: "",
      },
    });
  };

  useEffect(() => {
    if (isEdit) {
      formikRef.current.setFieldValue("name", currentPT.name);
      formikRef.current.setFieldValue("symbol", currentPT.symbol);
      formikRef.current.setFieldValue("iconImgUrl", currentPT.iconImgUrl);
      formikRef.current.setFieldValue(
        "contractAddress",
        currentPT.contractAddress
      );
      formikRef.current.setFieldValue("decimals", currentPT.decimals);
      formikRef.current.setFieldValue("totalTokens", currentPT.totalTokens);
      formikRef.current.setFieldValue("radius", currentPT.radius);
      formikRef.current.setFieldValue("blockchain", currentPT.blockchain);
      formikRef.current.setFieldValue("status", currentPT.status === "active");
      formikRef.current.setFieldValue(
        "worldwide",
        currentPT.worldwide === "active"
      );
      formikRef.current.setFieldValue(
        "socialHub",
        currentPT.socialHub === "active"
      );
    } else {
      formikRef.current.setFieldValue("name", "");
      formikRef.current.setFieldValue("symbol", "");
      formikRef.current.setFieldValue("iconImgUrl", "");
      formikRef.current.setFieldValue("contractAddress", "");
      formikRef.current.setFieldValue("decimals", "");
      formikRef.current.setFieldValue("totalTokens", "");
      formikRef.current.setFieldValue("radius", "");
      formikRef.current.setFieldValue("blockchain", "");
      formikRef.current.setFieldValue("status", "");
      formikRef.current.setFieldValue("worldwide", "");
      formikRef.current.setFieldValue("socialHub", "");
    }
  }, [currentPT]);

  return (
    <div>
      <div className="modaltitle">
        {`${isEdit ? "Edit" : "Add"}`} Partners Tokens
      </div>
      <Formik
        key="my-form"
        initialValues={{
          name: "",
          symbol: "",
          iconImgUrl: "",
          contractAddress: "",
          decimals: "",
          totalTokens: "",
          radius: "",
          blockchain: "",
          status: "",
          worldwide: "",
          socialHub: "",
        }}
        enableReinitialize={false}
        innerRef={formikRef}
        validationSchema={Constants.AddTokensSchema}
        onSubmit={(values, { resetForm }) => {
          if (isEdit) {
            const updatedBody = {
              tokenId: currentPT._id,
              name: values.name,
              symbol: values.symbol,
              contractAddress: values.contractAddress,
              decimals: values.decimals,
              totalTokens: values.totalTokens,
              radius: values.radius,
              blockchain: values.blockchain,
              status: values.status ? "active" : "disable",
              worldwide: values.worldwide ? "active" : "disable",
              socialHub: values.socialHub ? "active" : "disable",
            };
            dispatch({
              type: types.EditTokensRequest,
              payload: {
                updatedBody,
                handleCloseModal: () => {
                  handleCloseModal();
                  resetForm();
                },
                page,
              },
            });
          } else {
            let formData = new FormData();
            formData.append("name", values.name);
            formData.append("symbol", values.symbol);
            formData.append("iconImgUrl", !!imageFile ? BoastImageLink : "");
            formData.append("contractAddress", values.contractAddress);
            formData.append("decimals", values.decimals);
            formData.append("totalTokens", values.totalTokens);
            formData.append("radius", values.radius);
            formData.append("blockchain", values.blockchain);
            formData.append("status", values.status ? "active" : "disable");
            formData.append(
              "worldwide",
              values.worldwide ? "active" : "disable"
            );
            formData.append(
              "socialHub",
              values.socialHub ? "active" : "disable"
            );

            dispatch({
              type: types.CreateTokensRequest,
              payload: {
                formData,
                handleCloseModal: () => {
                  handleCloseModal();
                  resetForm();
                },
                page,
              },
            });
          }
        }}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          values,
          setFieldValue,
        }) => (
          <div className="formContainer">
            <div className="formHeader">
              <div className="formFields">
                <div
                  style={{
                    display: "flex",
                    gap: 32,
                    flexDirection: "row",
                  }}
                >
                  <UploadImage
                    setImageFile={setImageFile}
                    ErrorMessage={ErrorMessage}
                    setIsFirstTime={setIsFirstTime}
                    isFirstTime={isFirstTime}
                    formikRef={formikRef}
                    isEdit={isEdit}
                    currentPool={{ icon: currentPT?.iconImgUrl }}
                    loading={loading}
                  />
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-start",
                    }}
                  >
                    <Field name="symbol">
                      {({ meta }) => (
                        <CustomTextInput
                          label={"Symbol"}
                          type="text"
                          error={meta.touched ? meta.error : null}
                          onChange={(e) => {
                            if (e.target.value.length <= 75)
                              handleChange("symbol")(e);
                          }}
                          placeHolderText={"Enter symbol..."}
                          value={values.symbol}
                          onBlur={handleBlur("symbol")}
                          showEyeIcon={false}
                          required={true}
                          disable={loading}
                        />
                      )}
                    </Field>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "row",
                        gap: 24,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 4,
                          alignItems: "center",
                        }}
                      >
                        <label>Status*</label>
                        <Field name="status">
                          {() => (
                            <Switch
                              checked={values.status}
                              disabled={loading}
                              onChange={(checked) =>
                                setFieldValue("status", checked)
                              }
                            />
                          )}
                        </Field>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 4,
                          alignItems: "center",
                        }}
                      >
                        <label>Worldwide*</label>
                        <Field name="worldwide">
                          {() => (
                            <Switch
                              checked={values.worldwide}
                              disabled={loading}
                              onChange={(checked) =>
                                setFieldValue("worldwide", checked)
                              }
                            />
                          )}
                        </Field>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 4,
                          alignItems: "center",
                        }}
                      >
                        <label>SocialHub*</label>
                        <Field name="socialHub">
                          {() => (
                            <Switch
                              checked={values.socialHub}
                              disabled={loading}
                              onChange={(checked) =>
                                setFieldValue("socialHub", checked)
                              }
                            />
                          )}
                        </Field>
                      </div>
                    </div>
                  </div>
                </div>

                <Field name="name">
                  {({ meta }) => (
                    <CustomTextInput
                      label={"Name"}
                      type="text"
                      error={meta.touched ? meta.error : null}
                      onChange={(e) => {
                        if (e.target.value.length <= 25)
                          handleChange("name")(e);
                      }}
                      placeHolderText={"Enter name..."}
                      value={values.name}
                      onBlur={handleBlur("name")}
                      showEyeIcon={false}
                      required={true}
                      disable={loading}
                    />
                  )}
                </Field>
                <Field name="contractAddress">
                  {({ meta }) => (
                    <CustomTextInput
                      label={"Contract Address"}
                      type="text"
                      error={meta.touched ? meta.error : null}
                      onChange={(e) => {
                        if (e.target.value.length <= 75)
                          handleChange("contractAddress")(e);
                      }}
                      placeHolderText={"Enter contract Address..."}
                      value={values.contractAddress}
                      onBlur={handleBlur("contractAddress")}
                      showEyeIcon={false}
                      required={true}
                      disable={loading}
                    />
                  )}
                </Field>
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Field name="blockchain">
                    {({ meta }) => (
                      <CustomTextInput
                        label={"Blockchain type"}
                        type="text"
                        error={meta.touched ? meta.error : null}
                        onChange={(e) => {
                          if (e.target.value.length <= 75)
                            handleChange("blockchain")(e);
                        }}
                        placeHolderText={"Enter blockchain type..."}
                        value={values.blockchain}
                        onBlur={handleBlur("blockchain")}
                        showEyeIcon={false}
                        required={true}
                        disable={loading}
                      />
                    )}
                  </Field>
                  <Field name="decimals">
                    {({ meta }) => (
                      <CustomTextInput
                        label={"Decimals"}
                        type="number"
                        error={meta.touched ? meta.error : null}
                        onChange={(e) => {
                          if (e.target.value.length <= 75)
                            handleChange("decimals")(e);
                        }}
                        placeHolderText={"Enter decimals..."}
                        value={values.decimals}
                        onBlur={handleBlur("decimals")}
                        showEyeIcon={false}
                        required={true}
                        disable={loading}
                      />
                    )}
                  </Field>
                </div>

                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Field name="totalTokens">
                    {({ meta }) => (
                      <CustomTextInput
                        label={"Total Tokens"}
                        type="number"
                        error={meta.touched ? meta.error : null}
                        onChange={(e) => {
                          if (e.target.value.length <= 75)
                            handleChange("totalTokens")(e);
                        }}
                        placeHolderText={"Enter total Tokens..."}
                        value={values.totalTokens}
                        onBlur={handleBlur("totalTokens")}
                        showEyeIcon={false}
                        required={true}
                        disable={loading}
                      />
                    )}
                  </Field>
                  <Field name="radius">
                    {({ meta }) => (
                      <CustomTextInput
                        label={"Radius"}
                        type="number"
                        error={meta.touched ? meta.error : null}
                        onChange={(e) => {
                          if (e.target.value.length <= 75)
                            handleChange("radius")(e);
                        }}
                        placeHolderText={"Enter radius..."}
                        value={values.radius}
                        onBlur={handleBlur("radius")}
                        showEyeIcon={false}
                        required={true}
                        disable={loading}
                      />
                    )}
                  </Field>
                </div>
              </div>
            </div>

            <div className="formFooter">
              <button
                type="submit"
                disabled={loading}
                className="addbtn border p1060"
                onClick={() => {
                  handleSubmit();
                }}
              >
                {loading && <Spin className="spin" />}
                {isEdit ? "Edit" : "Add"}
              </button>
              <button
                type="submit"
                disabled={loading}
                className="cancelbtn border p1060"
                onClick={() => {
                  if (!isEdit) {
                    handleResetForm();
                  }
                  handleCloseModal();
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </Formik>
    </div>
  );
};

export default AddOrEditTokens;
